import { useNectarClickTracking } from '../../hooks/useNectarClickTracking';
import { useNectarPageView } from '../../hooks/useNectarPageView';

// Component that uses the analytics hooks
const AnalyticsTracker = () => {
  useNectarPageView();
  useNectarClickTracking();
  return null;
};

export default AnalyticsTracker;
